import React, { Component } from 'react';
import '../styles/HeroHeader.less';

class HeroHeader extends Component {

    render() {
        return (
            <section className="hero-header flex-container flex-container-center window-height" /*onClick={() => this.setState({value: this.state.value + 1})}*/>
                <div className="top flex-container flex-container-center">
                    <div>
                        <h1>Fortepiano</h1>
                        <p>by Kateryna Byelousova</p>
                    </div>
                </div>
                <div className="bottom flex-container">
                    <div className="key-distribute"><span></span></div>

                    <div className="key-distribute"><div></div><span></span></div>
                    <div className="key-distribute"><div></div><span></span></div>

                    <div className="key-distribute"><span></span></div>

                    <div className="key-distribute"><div></div><span></span></div>
                    <div className="key-distribute"><div></div><span></span></div>
                    <div className="key-distribute"><div></div><span></span></div>

                    <div className="key-distribute"><span></span></div>

                    <div className="key-distribute hidden-xs hidden-sm"><div></div><span></span></div>
                    <div className="key-distribute hidden-xs hidden-sm"><div></div><span></span></div>

                    <div className="key-distribute hidden-xs hidden-sm"><span></span></div>
                </div>
            </section>
        );
    }
}

export default HeroHeader;



// WEBPACK FOOTER //
// ./src/components/HeroHeader.js